import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { connect } from "react-redux";

import Dropdown from "../Dropdown";
import IconButton from "../IconButton";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const AllowedDepotsList = ({ t, column, value, depots, onPropChange }) => {
    const defaultControlCenter = { controlCenterId: 0, name: "-" };
    const [currentDepot, setCurrentDepot] = useState(defaultControlCenter);

    const getItems = () => {
        return [defaultControlCenter]
            .concat(depots
                .filter(depots => !Array.isArray(value) || !value.find(val=> val === depots.id))
            );
    }

    const getControlCenterName = id => {
        const depot = depots.find(f=> f.id === id) || {};
        return depot.name;
    }

    const handleOnChange = selectedDepots => {
        setCurrentDepot(selectedDepots);
    }

    const handleOnAdd = () => {
        if(currentDepot && currentDepot.id && column) {
            const currLength = getItems().length;
            onPropChange && onPropChange({ [column.accessor]: (value || []).concat(currentDepot.id) });
            if(currLength === 2) {
                setCurrentDepot(defaultControlCenter);
            }
        }
        setCurrentDepot(defaultControlCenter)
    }

    const handleOnDelete = controlCenterId => {
        if(controlCenterId && column && onPropChange) {
            onPropChange({ [column.accessor]: (value || []).filter(f=> f !== controlCenterId) });
        }
    }

    return (
        <div className={classNames("depotList")}>
            <div className={classNames("propItemLabel")}>{getTranslateTitle(column.title)}</div>
            <div className={classNames("depotAddSection")}>
                <Dropdown labelField="name" valueField="controlCenterId" searchBy="name"
                    value={(currentDepot || {}).name}
                    values={getItems()}
                    isRequired={column.isRequired}
                    isAccentuationByValue={column.isAccentuationByValue}
                    readonly={column.isReadonly}
                    onSelect={handleOnChange}
                />
                <IconButton isIcon={true} iconName="newOrder"
                    tooltipText={column.addTooltip || t("basic.ADD_BUTTON")}
                    onClick={handleOnAdd}
                />
            </div>
            <div className={classNames("depotSection")}>
                {(value || []).map(controlCenterId=> (
                    <div className={classNames("depotSectionItem")}>
                        <input type="text" readOnly="true" value={getControlCenterName(controlCenterId)} 
                            className={classNames("depotSectionItemLabel")}
                        />
                        <IconButton isIcon={true} iconName="orderDelete"
                            tooltipText={column.deleteTooltip || t("basic.DELETE_BUTTON")}
                            onClick={()=> handleOnDelete(controlCenterId)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    depots: state.restaurant.data.depots || []
});

export default connect(mapStateToProps)(withTranslation()(AllowedDepotsList));